import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaDatePickerComponent from './VaDatePicker.vue'

export const VaDatePicker = withConfigTransport(VaDatePickerComponent)
